import React, { useEffect, useState } from 'react';
import { fetchNotifications } from '../api/notifications';
import { Box, Typography, Card, CardContent, CircularProgress } from '@mui/material';
import { format } from 'date-fns';
import NavBar from '../components/NavBar';
import { useAuth } from '../contexts/AuthContext';

const UpdatesPage = () => {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    fetchNotifications().then((data) => {
      setUpdates(data);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <NavBar user={user} />
      <Box sx={{ maxWidth: 600, mx: 'auto', mt: 5, p: 2, minHeight: '80vh' }}>
        <Typography variant="h4" fontWeight={700} gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
          Updates
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {updates.map((update) => (
              <Card key={update.id} sx={{ bgcolor: 'background.paper', borderRadius: 2, boxShadow: 2 }}>
                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <span style={{ fontSize: '1.5rem' }}>{update.emoji}</span>
                  <Box>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {update.title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {format(new Date(update.date), 'MMMM d, yyyy')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      {update.description}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default UpdatesPage; 